var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.53 3.871a2.483 2.483 0 0 1 2.482 2.482v11.294a2.483 2.483 0 0 1-2.483 2.483H4.471a2.483 2.483 0 0 1-2.483-2.483V6.353a2.483 2.483 0 0 1 2.483-2.482zM3.186 17.647c0 .709.575 1.283 1.284 1.283h15.058c.708 0 1.282-.575 1.282-1.283v-9.26l-7.54 4.804-.02.013a2.48 2.48 0 0 1-2.494 0l-.02-.013-7.55-4.804zM4.472 5.07c-.708 0-1.283.575-1.283 1.283v.612l8.174 5.202a1.284 1.284 0 0 0 1.278.002l8.172-5.203v-.613c0-.708-.575-1.283-1.283-1.283z"
  })));
};
export default SvgMail;